import api from './axios';

export const registerApi   = (data) => api.post('/auth/register', data);
export const loginApi      = (data) => api.post('/auth/login', data);
export const getMeApi      = ()     => api.get('/auth/me');
export const forgotPassApi = (data) => api.post('/auth/forgot-password', data);
export const resetPassApi  = (data) => api.post('/auth/reset-password', data);
